import { ArrowsIn, ArrowsOut } from '@phosphor-icons/react'
import PrivateRoute from 'components/PrivateRoute'
import FormsPage from 'pages/FormsPage'
import PacketsPage from 'pages/PacketsPage'
import TabletModeFill from 'pages/tabletMode/TabletModeFill'
import * as React from 'react'
import { FullScreen, useFullScreenHandle } from 'react-full-screen'
import { Switch } from 'react-router-dom'
import { ContextTabletModeProvider } from 'utils/ContextTabletMode'
import { ZentakeContext } from 'utils/ZentakeContext'

import TabletModeMenu from './TabletModeMenu'
import TabletModePatientForm from './TabletModePatientForm'
import TabletModeQueue from './TabletModeQueue'

function TabletModeMainFC() {
  const fullScreenHandler = useFullScreenHandle()
  const { setTabletModeLockDown, tabletModeLockDown } =
    React.useContext(ZentakeContext)

  const isFullscreenSupported = React.useMemo(() => {
    return (
      document.fullscreenEnabled ||
      document.webkitFullscreenEnabled ||
      document.mozFullScreenEnabled ||
      document.msFullscreenEnabled
    )
  }, [])

  React.useEffect(() => {
    if (!tabletModeLockDown) {
      setTabletModeLockDown(true)
    }
  }, [setTabletModeLockDown, tabletModeLockDown])

  return (
    <FullScreen className="bg-red-500" handle={fullScreenHandler}>
      <div className="min-h-screen bg-screen">
        <Switch>
          {/* Main menu */}
          <PrivateRoute
            exact
            skipLockdown
            component={TabletModeMenu}
            path="/t"
          />
          {/* Packets list */}
          <PrivateRoute
            exact
            skipLockdown
            component={() => <PacketsPage tabletMode />}
            path="/t/p"
          />
          {/* Forms list */}
          <PrivateRoute
            exact
            skipLockdown
            path="/t/f"
            render={() => <FormsPage tabletMode />}
          />
          {/* Queue list */}
          <PrivateRoute
            exact
            skipLockdown
            component={TabletModeQueue}
            path="/t/q"
          />
          {/* User data getter */}
          <PrivateRoute
            exact
            skipLockdown
            component={TabletModePatientForm}
            path="/t/f/:sessionId"
          />
          <PrivateRoute
            exact
            skipLockdown
            component={TabletModePatientForm}
            path="/t/p/:sessionId"
          />
          <PrivateRoute
            skipLockdown
            component={TabletModeFill}
            path="/t/:resourceType/:sessionId/:mode"
          />
        </Switch>
      </div>

      {!fullScreenHandler.active && isFullscreenSupported ? (
        <button
          className="fixed right-0 top-0 z-50 m-2 rounded-full bg-txt-disabled p-2 transition-colors hover:bg-txt"
          onClick={fullScreenHandler.enter}
        >
          <ArrowsOut className="text-xl text-white" />
        </button>
      ) : null}
      {fullScreenHandler.active && isFullscreenSupported ? (
        <button
          className="fixed right-0 top-0 z-50 m-2 rounded-full bg-txt-disabled p-2 transition-colors hover:bg-txt"
          onClick={fullScreenHandler.exit}
        >
          <ArrowsIn className="text-xl text-white" />
        </button>
      ) : null}
    </FullScreen>
  )
}

function TabletModeMain(props) {
  const { userDetails } = React.useContext(ZentakeContext)
  if (userDetails && !userDetails.is_verified) {
    window.close()
    return null
  }

  return (
    <ContextTabletModeProvider>
      <TabletModeMainFC {...props} />
    </ContextTabletModeProvider>
  )
}

export default TabletModeMain
